import type { RootState } from '~/reducers';

import type { WeddingPreferencesState } from '../reducers/weddingPreferencesReducer';

export const getHasWeddingPreferences = (state: RootState): boolean =>
  state.weddingPreferences.loaded && Boolean(state.weddingPreferences.uuid);

export const getWeddingPreferencesLoaded = (state: RootState): boolean =>
  state.weddingPreferences.loaded;

export const getWeddingPreferences = (state: RootState): WeddingPreferencesState =>
  state.weddingPreferences;
